import { Suspense } from "react";

import { RootComponentInstance } from "@uniformdev/canvas";

import ContentNotFoundErrorBoundary from "@/content/utils/content-not-found-error-boundary";
import { FourOhFourPageTemplate } from "@/templates/404/404-page/src/404-page.template";

import { TestUniformPageTemplate } from "../../templates/test-uniform/test-uniform-page/src";

export type TestUniformPageProps = {
    composition: RootComponentInstance;
    isUniformPlayground?: boolean;
};
export const TestUniformPage = ({
    composition,
    isUniformPlayground
}: TestUniformPageProps) => (
    <ContentNotFoundErrorBoundary fallback={<FourOhFourPageTemplate />}>
        <Suspense>
            <TestUniformPageTemplate
                composition={composition}
                isUniformPlayground={isUniformPlayground}
            />
        </Suspense>
    </ContentNotFoundErrorBoundary>
);
